export const SkillsData = [
  {
    type: 'Front-End',
    list: [
      {
        name: 'ReactJS',
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: 'HTML5',
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: 'JavaScript',
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: 'CSS',
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: 'TailwindCSS',
        icon: <i class="devicon-tailwindcss-plain colored"></i>,
      },
    ],
  },
  {
    type: 'Other Skills',
    list: [
      {
        name: 'MongoDB',
        icon: <i class="devicon-mongodb-plain-wordmark colored"></i>,
      },
      {
        name: 'Bootstrap',
        icon: <i class="devicon-bootstrap-plain colored"></i>,
      },
      {
        name: 'PostgreSQL',
        icon: <i class="devicon-postgresql-plain-wordmark colored"></i>,
      },
      {
        name: 'Java',
        icon: <i class="devicon-java-plain colored"></i>,
      },
      {
        name: 'Git',
        icon: <i class="devicon-git-plain-wordmark colored"></i>,
      },
    ],
  },
];
